module.exports = __webpack_public_path__ + "media/images/requisitions/pc_bg-3d10cdf35203e0766526a0c4fa6765e3.png";